"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormControlLabel_1 = require("./FormControlLabel");
exports.default = FormControlLabel_1.default;
//# sourceMappingURL=index.js.map